<template xmlns:th="http://www.w3.org/1999/xhtml">
    <div class="orderDetail print">
<!--        <el-card class="noprint">-->
<!--            <el-page-header v-if="from == 'rfq'" @back="goBack" :content="'订单详情('+ orderId + ')'"></el-page-header>-->
<!--            <el-breadcrumb v-if="from == 'menu'" separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>订单管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>订单详情</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <div style="text-align: right;padding-bottom: 10px; display: none;" class="noprint">
                <el-button  v-if="showBtn"
                        size="min"  @click="orderIt(orderId,
                                    name,totalPrice)"
                        type="primary">下单</el-button>
                <el-button size="min"  @click="printOrder" type="primary">打印</el-button>
            </div>

            <div class="quote mt20 mb60 pt10">
                <div class="clearfix" >
                    <div class="fl" style="font-size: 14px;float: left;font-weight: bold;line-height: 20px;">
                        <div><span>订单编号：</span><span>{{infoData.order.orderNo}}</span></div>
                        <div><span>订单日期：</span><span >{{infoData.order.createTime}}</span></div>
                        <div><a href="https://mro.tcmtc.com.cn/" style="color:#000">https://mro.tcmtc.com.cn</a></div>
                    </div>
                    <div class="fr" style="text-align: right"><img src="../../assets/logo3.png" alt="" width="300"/></div>
                </div>
                <div style="width:100%;" >
                    <div>
                        <table style="width: 500px !important;float:right;margin-right: 0 !important;" border="1">
                            <tr style="width: 500px;" >
                                <th colspan="2" style="padding: 3px; background: #dfdfdf">销售订单</th>
                            </tr>
                            <tr style="width: 500px;">
                                <td style="padding: 3px;width: 120px;">客户编号：</td>
                                <td style="padding: 3px;min-width: 300px;">{{infoData.company == null ? '-':infoData.company.code}}</td>
                            </tr>
                            <tr style="width: 500px;">
                                <td style="padding: 3px;width: 100px;">客户名称：</td>
                                <td style="padding: 3px;min-width: 300px;">{{infoData.company == null ? '-':infoData.company.name}}</td>
                            </tr>
                            <tr style="width: 500px;">
                                <td style="padding: 3px;width: 90px;">订单日期：</td>
                                <td style="padding: 3px;min-width: 300px;">{{infoData.order.createTime}}</td>
                            </tr>
                            <tr style="width: 500px;">
                                <td style="padding: 3px;width: 90px;">订单联系人：</td>
                                <td style="padding: 3px;min-width: 300px;">{{infoData.order.consignee}}</td>
                            </tr>
                            <tr style="width: 500px;">
                                <td style="padding: 3px;width: 90px;">订单状态：</td>
                                <td style="padding: 3px;min-width: 300px;">{{infoData.order.showStatus}}</td>
                            </tr>
                            <tr style="width: 500px;" v-if="infoData.order.status == 6">
                                <td style="padding: 3px;width: 90px;">驳回原因：</td>
                                <td style="padding: 3px;min-width: 300px;" >{{infoData.order.rejectOrderReason}}</td>
                            </tr>
                        </table>
                        <div style="clear: both"></div>
                    </div>
                </div>
                <div style="margin: 16px 0;clear: both;"><span style="font-size: 16px">订单进度查询：合同生效后，甲方及其采购人员可以通过鹏龙天创MRO平台(<a href="https://mro.tcmtc.com.cn/" style="color:#000">https://mro.tcmtc.com.cn</a>)查看订单处理进度，如有疑问或问题请联系为您服务的客服。</span></div>
                <div style="margin-top: 16px;"><span>1. 产品信息</span></div>
                <div style="margin-top: 3px;">
                    <table border="1" style="table-layout: fixed; width: 100%">
                        <tr style="width: 100%;background: #dfdfdf;">
                            <th style="width: 60px">序号</th>
                            <th style="width: 120px">商品编码</th>
                            <th  style="width: 150px">产品名称</th>
                            <th style="width: 130px">品牌</th>
                            <th style="width: 130px">规格型号</th>
                            <th style="width: 90px">数量</th>
                            <th style="width: 120px">未税单价</th>
                            <th style="width: 120px">含税单价</th>
                            <th style="width: 120px">未税总价</th>
                            <th style="width: 120px">含税总价</th>
                        </tr>
                        <tr style="width: 100%" v-for="(item,i) in proData" :key="item.id+'_d'">
                            <td align="center" style="padding: 0 5px; width: 50px;">{{i+1}}</td>
                            <td align="center" style="padding: 0 5px; width: 110px" >{{item.sku}}</td>
                            <td align="left"  style="padding: 0 5px; width: 200px" >({{ item.supplier }}) {{item.shortName ? item.shortName : item.name}}</td>
                            <td align="center"  style="padding: 0 5px;width: 120px">{{item.brand}}</td>
                            <td align="center"  style="padding: 0 5px;width: 120px">{{item.model}}</td>
                            <td align="center"   style="padding: 0 5px;" >{{item.unit === null ? item.num+'件' : item.num+item.unit}}</td>
                            <td align="center"   style="padding: 0 5px;">{{'￥'+item.untaxedPrice+'元'}}</td>
                            <td align="center" style="padding: 0 5px;" >{{'￥'+item.price+'元'}}</td>
                            <td align="center"  style="padding: 0 5px;" >{{'￥'+item.totalUntaxedPrice+'元'}}</td>
                            <td align="center"  style="padding: 0 5px;">{{'￥'+item.totalPrice+'元'}}</td>
                        </tr>
                        <tr style="width: 100%">
                            <th colspan="2"  style="width: 181px;background: #dfdfdf;">商品未税总价(CNY)：</th>
                            <td colspan="8" style="padding: 0 5px;">{{"￥"+infoData.order.totalUntaxedPrice+"元"}}</td>
                        </tr>
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 181px;background: #dfdfdf;">商品含税总价(CNY)：</th>
                            <td colspan="8" style="padding: 0 5px;" >{{"￥"+infoData.order.totalPrice+"元"}}</td>
                        </tr>
                    </table>
                </div>
                <div><span>说明：本合同金额不包括现场服务费及安装费用，合同中明确包含“现场服务费”除外。</span></div>

                <div style="margin-top: 16px;"><span>2. 其他费用</span></div>
                <div style="margin-top: 3px;">

                    <table border="1" style="table-layout: fixed; width: 100%">
                        <tr style="width: 100%">
                            <th colspan="2"  style="width: 181px;background: #dfdfdf;">运费(CNY)：</th>
                            <td colspan="8" style="padding: 0 5px;">{{"￥"+infoData.order.freight+"元"}}</td>
                        </tr>
                    </table>
                </div>

                <div style="margin-top: 16px;"><span>3. 开票资料信息</span></div>
                <div style="margin-top: 3px;">
                   <table border="1" style="table-layout: fixed; width: 100%">
                       <tr style="width: 100%">
                           <th style="width: 120px;background: #dfdfdf;">公司名称：</th>
                           <td colspan="3" style="width: 467px;padding: 0 5px;">{{infoData.order.invoiceCompanyName ? infoData.order.invoiceCompanyName:'-'}}</td>
                           <th style="width: 120px;background: #dfdfdf;">发票类型：</th>
                           <td colspan="3" style="width: 467px;padding: 0 5px;">增值税发票</td>

                       </tr>
                       <tr style="width: 100%">
                           <th style="width: 120px;background: #dfdfdf;">开户银行：</th>
                           <td colspan="3" style="width: 467px;padding: 0 5px;">{{infoData.order.invoiceBankName ? infoData.order.invoiceBankName:'-'}}</td>
                           <th style="width: 120px;background: #dfdfdf;">注册电话：</th>
                           <td colspan="3" style="width: 467px;padding: 0 5px;">{{infoData.order.invoiceCompanyTel ? infoData.order.invoiceCompanyTel:'-'}}</td>

                       </tr>
                       <tr style="width: 100%">
                           <th style="width: 120px;background: #dfdfdf;">银行账号：</th>
                           <td colspan="3" style="width: 467px;padding: 0 5px;">{{infoData.order.invoiceBankAccount ? infoData.order.invoiceBankAccount:'-'}}</td>
                           <th style="width: 120px;background: #dfdfdf;">注册地址：</th>
                           <td colspan="3" style="width: 467px;padding: 0 5px;">{{infoData.order.invoiceCompanyAddress ? infoData.order.invoiceCompanyAddress:'-'}}</td>

                       </tr>
                       <tr style="width: 100%">
                           <th style="width: 120px;background: #dfdfdf;">公司税号：</th>
                           <td colspan="3" style="width: 467px;padding: 0 5px;">{{infoData.order.invoiceCompanyTaxNo ? infoData.order.invoiceCompanyTaxNo:'-'}}</td>
                           <th style="width: 120px;background: #dfdfdf;">备注信息：</th>
                           <td colspan="3" style="width: 467px;padding: 0 5px;">-</td>

                       </tr>
                   </table>
                </div>

                <div style="margin-top: 16px;"><span>4. 货物接收信息</span></div>
                <div style="margin-top: 3px;">

                    <table border="1" style="table-layout: fixed; width: 100%">
                        <tr style="width: 100%">
                            <th style="width: 120px;background: #dfdfdf;">货物接收地址：</th>
                            <td colspan="3" style="width: 467px;padding: 0 5px;">{{infoData.order.province+infoData.order.city +infoData.order.county + infoData.order.address}}</td>
                            <th style="width: 120px;background: #dfdfdf;">接收人：</th>
                            <td style="width: 168px;padding: 0 5px;" >{{infoData.order.consignee}}</td>
                            <th style="width: 120px;background: #dfdfdf;">手机：</th>
                            <td style="width: 167px;padding: 0 5px;" >{{infoData.order.mobile}}</td>
                        </tr>
                    </table>
                </div>
                <div style="margin-top: 16px;">
                    <div>售后服务：</div>
                    <div><span style="width:100px;display: inline-block;">1.华为正天：</span>010-56120100 / 13658485913(刘工)</div>
                    <div><span style="width:100px;display: inline-block;">2.霍夫曼：</span>400-821-3512</div>
                    <div><span style="width:100px;display: inline-block;">3.科力普：</span>400-118-8366</div>
                    <div><span style="width:100px;display: inline-block;">4.领先未来：</span>400-888-1123</div>
                    <div><span style="width:100px;display: inline-block;">5.西域：</span>400-821-8800</div>
                </div>
                <div style="margin-top: 16px;">
                    <div>备注：</div>
                    <div>1.在中华人民共和国境内，对于净值超过人民币300元的订单我们提供免费寄送服务。对于订货金额低于人民币300元的订单，我们将收取每单40元的送货费。</div>
                    <div>2.对于错订的物品，我们将收取10%的退货费，最少100元起。</div>
                    <div>3.货物运输至中国境内客户指定地点。</div>
                    <div>4.新疆、西藏、青海等偏远地区的最小订单金额、运费及货期以实际报价阶段为准。</div>
                </div>
            </div>


<!--            <el-card style="border: #409eff">-->
<!--                <div id="p" ref="p"  >-->
<!--                    <div style="margin: 0;">-->
<!--                        <div style="font-size: 14px;font-weight: bold;line-height: 20px;float: left;">-->
<!--                            <div><span>订单编号：</span><span >{{infoData.order.id}}</span></div>-->
<!--                            <div><span>订单日期：</span><span >{{infoData.order.createTime}}</span></div>-->
<!--                            <div><a href="https://mro.tcmtc.com.cn/" style="color:#000">https://mro.tcmtc.com.cn</a></div>-->
<!--                        </div>-->
<!--                        <div class="fr" style="text-align: right"><img src="../../assets/logo3.png" alt="" width="300"/></div>-->
<!--                    </div>-->

<!--                    <div style="width:100%;clear: both;" >-->
<!--                        <div style="clear: both;">-->

<!--                            <el-table style="font-size: 14px;float:right;margin-right: 0 !important;"-->
<!--                                      v-loading="loading1" border-->
<!--                                      :data="orderData" class="tableBaseInfo el-table-order"-->
<!--                                      size="mini" :header-cell-style="tableHeaderColor" :cell-style="columnStyleO"-->
<!--                                      :header-row-class-name="hiddenHeaderRow" >-->
<!--                                <el-table-column label="销售订单" align="center" >-->
<!--                                    <el-table-column prop="name" align="center" width="150px"></el-table-column>-->
<!--                                    <el-table-column prop="nameValue" align="center" ></el-table-column>-->
<!--                                </el-table-column>-->
<!--                            </el-table>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div style="clear: both;margin-top: 5px;">-->
<!--                        <div style="margin: 16px 0;"><span style="font-size: 16px">订单进度查询：合同生效后，甲方及其采购人员可以通过鹏龙天创MRO平台(<a href="https://mro.tcmtc.com.cn/" style="color:#000">https://mro.tcmtc.com.cn</a>)查看订单处理进度，如有疑问或问题请联系为您服务的客服。</span></div>-->
<!--                        <div style="margin-top: 16px;"><span style="font-size: 12px">1. 产品信息</span></div>-->
<!--                    </div>-->
<!--                    <div style="border: #409eff;background: #409eff">-->
<!--                        <el-table-->
<!--                                :data="proData"-->
<!--                                v-loading="loading"-->
<!--                                :header-cell-style="tableHeaderColor" border-->
<!--                                class="tableBaseInfo el-table-o" :cell-style="columnStyleO"-->
<!--                                style="width: 100%;border-bottom: none !important;">-->
<!--                            <el-table-column type="index" label="序号" width="55"/>-->
<!--                            <el-table-column prop="sku" label="商品编码" min-width="8%"/>-->
<!--                            <el-table-column prop="name" label="产品名称" min-width="8%" />-->
<!--                            <el-table-column prop="brand" label="品牌" min-width="10%" align="center"/>-->
<!--                            <el-table-column prop="model" label="规格型号" width="120" align="center"/>-->
<!--                            <el-table-column prop="num" label="数量" width="80" align="center">-->
<!--                                <template slot-scope="scope">-->
<!--                                    {{scope.row.unit === null ? scope.row.num+'件' : scope.row.num+scope.row.unit}}-->
<!--                                </template>-->
<!--                            </el-table-column>-->

<!--                            <el-table-column-->
<!--                                    prop="untaxedPrice"-->
<!--                                    label="未税单价(元)"-->
<!--                                    width="120"-->
<!--                                    align="center">-->
<!--                                <template slot-scope="scope">-->
<!--                                    {{'￥'+scope.row.untaxedPrice+'元'}}-->
<!--                                </template>-->
<!--                            </el-table-column>-->
<!--                            <el-table-column-->
<!--                                    prop="price"-->
<!--                                    label="含税单价(元)"-->
<!--                                    width="100"-->
<!--                                    align="center">-->
<!--                                <template slot-scope="scope">-->
<!--                                    {{'￥'+scope.row.price+'元'}}-->
<!--                                </template>-->
<!--                            </el-table-column>-->
<!--                            <el-table-column-->
<!--                                    prop="totalUntaxedPrice"-->
<!--                                    label="未税总价(元)"-->
<!--                                    width="100"-->
<!--                                    align="center">-->
<!--                                <template slot-scope="scope">-->
<!--                                    {{'￥'+scope.row.totalUntaxedPrice+'元'}}-->
<!--                                </template>-->
<!--                            </el-table-column>-->
<!--                            <el-table-column prop="totalPrice" label="含税总价(元)"-->
<!--                                             width="100" align="center">-->
<!--                                <template slot-scope="scope">-->
<!--                                    {{'￥'+scope.row.totalPrice+'元'}}-->
<!--                                </template>-->
<!--                            </el-table-column>-->
<!--                            <el-table-column-->
<!--                                    prop="supplierOrderUntaxedPrice"-->
<!--                                    label="供应商未税单价(元)"-->
<!--                                    width="100"-->
<!--                                    align="center">-->
<!--                                <template slot-scope="scope">-->
<!--                                    {{'￥'+scope.row.supplierOrderUntaxedPrice+'元'}}-->
<!--                                </template>-->
<!--                            </el-table-column>-->
<!--                            <el-table-column-->
<!--                                    prop="supplierOrderPrice"-->
<!--                                    label="供应商已税单价(元)"-->
<!--                                    width="100"-->
<!--                                    align="center">-->
<!--                                <template slot-scope="scope">-->
<!--                                    {{'￥'+scope.row.supplierOrderPrice+'元'}}-->
<!--                                </template>-->
<!--                            </el-table-column>-->

<!--                            <el-table-column-->
<!--                                    prop="supplierOrderTotalUntaxedPrice"-->
<!--                                    label="供应商未税总价(元)"-->
<!--                                    width="100"-->
<!--                                    align="center">-->
<!--                                <template slot-scope="scope">-->
<!--                                    {{'￥'+scope.row.supplierOrderTotalUntaxedPrice+'元'}}-->
<!--                                </template>-->
<!--                            </el-table-column>-->
<!--                            <el-table-column-->
<!--                                    prop="supplierOrderTotalPrice"-->
<!--                                    label="供应商已税总价(元)"-->
<!--                                    width="100"-->
<!--                                    align="center">-->
<!--                                <template slot-scope="scope">-->
<!--                                    {{'￥'+scope.row.supplierOrderTotalPrice+'元'}}-->
<!--                                </template>-->
<!--                            </el-table-column>-->

<!--                        </el-table>-->
<!--                        <el-table-->
<!--                                :data="taxData" class="el-table-o"-->
<!--                                size="mini" border :cell-style="columnStyle"-->
<!--                                style="width: 100%;font-size: 14px" :show-header="false">-->
<!--                            <el-table-column prop="name" align="center" min-width="21%"></el-table-column>-->
<!--                            <el-table-column prop="nameValue" style="width: 79%"></el-table-column>-->


<!--                        </el-table>-->
<!--                    </div>-->

<!--                    <div><span style="font-size: 12px">说明：本合同金额不包括现场服务费及安装费用，合同中明确包含“现场服务费”除外。</span></div>-->
<!--                    <div style="margin-top: 16px;font-size: 12px"><span>2. 开票资料信息</span></div>-->
<!--                    <el-table class="el-table-o"-->
<!--                            :data="invoiceData"-->
<!--                            size="mini" border :cell-style="columnStyle"-->
<!--                            :show-header="false" style="width: 100%;font-size: 14px"-->
<!--                    >-->
<!--                        <el-table-column prop="label1" align="center" min-width="21%"></el-table-column>-->
<!--                        <el-table-column prop="v1" min-width="29%"></el-table-column>-->
<!--                        <el-table-column prop="label2" align="center" min-width="21%"></el-table-column>-->
<!--                        <el-table-column prop="v2" min-width="29%"></el-table-column>-->

<!--                    </el-table>-->
<!--                    <div style="margin-top: 16px;font-size: 12px"><span>3. 发票及货物接收信息</span></div>-->
<!--                    <el-table class="el-table-o"-->
<!--                            :data="deliverData" :cell-style="columnStyle"-->
<!--                            size="mini" border :show-header="false" style="font-size: 14px">-->

<!--                        <el-table-column prop="label1" align="center" width="150px" :style="{fontWeight:400}"></el-table-column>-->
<!--                        <el-table-column prop="v1" min-width="30%"></el-table-column>-->
<!--                        <el-table-column prop="label2" align="center" width="150px"></el-table-column>-->
<!--                        <el-table-column prop="v2" min-width="30%"></el-table-column>-->

<!--                    </el-table>-->


<!--                    <div style="font-size: 12px">-->
<!--                        <div>备注：</div>-->
<!--                        <div>1.在中华人民共和国境内，对于净值超过人民币300元的订单我们提供免费寄送服务。对于订货金额低于人民币300元的订单，我们将收取每单40元的送货费。</div>-->
<!--                        <div>2.对于错订的物品，我们将收取10%的退货费，最少100元起。</div>-->
<!--                        <div>3.货物运输至中国境内客户指定地点。</div>-->
<!--                        <div>4.新疆、西藏、青海等偏远地区的最小订单金额、运费及货期以实际报价阶段为准。</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </el-card>-->
        </main>
        <el-dialog title="" :visible.sync="reviewVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="reviewForm" :model="reviewForm" :rules="rules" label-width="100px">
                <el-form-item label="审核结果" prop="pass"  v-if="false">
                    <el-select v-model="reviewForm.pass" placeholder="" >
                        <el-option label="通过" value="true"></el-option>
                        <el-option label="拒绝" value="false"></el-option>

                    </el-select>
                </el-form-item>
                <el-form-item label="驳回原因" prop="reason" v-if='reviewForm.pass == "false"'>
                    <el-input v-model="reviewForm.reason" placeholder="请输入驳回原因" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reviewVisible = false">取 消</el-button>
                <el-button type="primary" @click="addProcess()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import html2canvas from "html2canvas";
    import printJS from "print-js";
    export default {
        data() {
            return {

                loading: false,
                loading1: false,
                total: 0,
                pageSize: 10,
                currentPage: 1,
                tableData: [],
                reviewVisible:false,
                reviewForm: {
                    name:"",//收货人
                    pass:true,
                    reason: "",
                    workflowId:"",
                    step:"",
                    orderId:"",
                    totalPrice:""
                },
                infoData:{},
                invoiceData: [],//发票信息
                deliverData: [],//发票及货物接收信息
                orderData:[],//销售订单
                taxData: [],//含税价格
                proData: [],//产品信息



            }
        },
        props: ["from", "orderId","name","totalPrice","showBtn"],

        methods: {
            onSearch() {
                const url = "/admin/rfq/adminOrderDetail";
                if(this.orderId) {
                    this.loading = true;
                    let _this = this
                    this.$axios.post(url,{
                        cond:{orderId:this.orderId},
                        page: this.currentPage - 1,size:this.pageSize
                    }).then(function(response) {
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            _this.loading = false;
                            _this.tableData = resp.data.content;
                            _this.total = resp.data.totalElements;
                        }
                    }).catch(function() {
                    });
                }
            },
            info() {
                const url = "/admin/rfq/orderInfo";
                if(this.orderId) {
                    this.loading1 = true;
                    let _this = this
                    this.$axios.post(url,{orderId:this.orderId}).then(function(response) {
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            _this.loading1 = false;
                            _this.infoData = resp.data;
                            _this.proData = _this.infoData.orderDetails;

                            _this.orderData = [{name: "客户编号：",nameValue: _this.infoData.company.code},
                                {name: "客户名称：",nameValue: _this.infoData.company.name},
                                {name: "订单日期：",nameValue: _this.infoData.order.createTime},
                                {name: "订单联系人：",nameValue: _this.infoData.order.consignee},
                                {name: "订单状态：",nameValue: _this.infoData.order.showStatus}];
                            if(_this.infoData.order.status == 6){
                                _this.orderData = [{name: "客户编号：",nameValue: _this.infoData.company.code},
                                    {name: "客户名称：",nameValue: _this.infoData.company.name},
                                    {name: "订单日期：",nameValue: _this.infoData.order.createTime},
                                    {name: "订单联系人：",nameValue: _this.infoData.order.consignee},
                                    {name: "订单状态：",nameValue: _this.infoData.order.showStatus},
                                    {name: "驳回原因：",nameValue: _this.infoData.rejectOrderReason}];

                            }


                            _this.taxData = [{name: "商品未税总价(CNY)：",nameValue: "￥"+_this.infoData.order.totalUntaxedPrice+"元"},
                                {name: "商品含税总价(CNY)：",nameValue: "￥"+_this.infoData.order.totalPrice+"元"}];

                            let invoice =
                                {
                                    label1: "公司名称：",
                                    v1: _this.infoData.company==null?'-':_this.infoData.company.name,
                                    label2: "发票类型：",
                                    v2: _this.infoData.invoice==null?'-':_this.infoData.invoice.showType,

                                }
                            let invoice2 =
                                {
                                    label1: "开户银行：",
                                    v1: _this.infoData.invoice==null?'-':_this.infoData.invoice.bankName,
                                    label2: "注册电话：",
                                    v2: _this.infoData.invoice==null?'-':_this.infoData.invoice.registeredTel,

                                }
                            let invoice3 =
                                {
                                    label1: "银行账号：",
                                    v1: _this.infoData.invoice==null?'-':_this.infoData.invoice.bankAccount,
                                    label2: "注册地址：",
                                    v2: _this.infoData.invoice==null?'-':_this.infoData.invoice.registeredAddress,

                                }
                            let invoice4 =
                                {
                                    label1: "公司税号：",
                                    v1:  _this.infoData.invoice==null?'-':_this.infoData.invoice.companyTaxNo,
                                    label2: "备注信息：",
                                    v2: '-',

                                }
                            let d2 = [invoice,invoice2,invoice3,invoice4];

                            _this.invoiceData = d2;

                            let invoice5 =
                                {
                                    label1: "发票接收地址：",
                                    v1:  _this.infoData.order.province+ _this.infoData.order.city + _this.infoData.order.county + _this.infoData.order.address,
                                    label2: "货物接收地址：",
                                    v2:  _this.infoData.order.province+ _this.infoData.order.city + _this.infoData.order.county + _this.infoData.order.address,

                                }
                            let invoice6 =
                                {
                                    label1: "接收人：",
                                    v1:  _this.infoData.order.consignee,
                                    label2: "手机：",
                                    v2:  _this.infoData.order.mobile,

                                }
                            _this.deliverData = [invoice5,invoice6];

                        }
                    }).catch(function() {
                    });
                }
            },
            onPageChange(currentPage) {
                this.currentPage = currentPage;
                this.onSearch();
            },
            goBack() {
                this.$router.go(-1);
            },
            passIt(orderId,step,workflowId,name,totalPrice){

                this.reviewForm.pass = 'true';
                this.reviewForm.reason = '';
                this.reviewForm.orderId = orderId;

                if(this.reviewForm.step == undefined) {
                    this.reviewForm.step = step;

                    this.reviewForm.workflowId = workflowId;

                }


                this.reviewForm.name = name;
                this.reviewForm.totalPrice = totalPrice;
                this.addProcess();
            },
            showReviewDialog(orderId,step,workflowId,name,totalPrice) {//打开审核对话框
                this.reviewForm.pass = 'false';
                this.reviewForm.reason = '';
                this.reviewForm.orderId = orderId;

                if(this.reviewForm.step == undefined) {
                    this.reviewForm.step = step;
                    this.reviewForm.workflowId = workflowId;

                }

                this.reviewForm.name = name;
                this.reviewForm.totalPrice = totalPrice;
                this.reviewVisible = true;

            },
            addProcess() {//添加审核过程

                const that = this;
                let cond = {...this.reviewForm};

                let optate = "通过";
                optate = cond.pass == 'false' ? "驳回" : "通过";
                this.$confirm('确定' + optate +'【' +cond.name+'】提交的总价【￥'+cond.totalPrice+'】的订单吗？', '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {

                    cond.pass = cond.pass == 'true' ? true : false;
                    if (cond.pass) {
                        cond.reason = '';
                    }
                    cond={pass:cond.pass,reason:cond.reason,orderId:cond.orderId,step:cond.step
                        ,workflowId:cond.workflowId};
                    this.$axios.post("/admin/rfq/review", cond)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {

                                that.reviewVisible = false;
                                that.getStep(that.reviewForm.orderId);
                                if (resp.data == true) {//审核完毕
                                    that.changeOrder(that.reviewForm.orderId);
                                    that.info()();
                                } else {
                                    that.$notify({
                                        title: '成功',
                                        message: '数据保存成功',
                                        type: 'success'
                                    });
                                    that.info()();
                                }


                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                });

            },
            changeOrder(orderId) {//修改状态为下单
                const that = this;
                this.$axios.post("/admin/rfq/reviewOver", {orderId:orderId})
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {

                            if(resp.data == true){//审核完毕
                                that.$notify({
                                    title: '成功',
                                    message: '已下单',
                                    type: 'success'
                                });


                            }

                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            },
            getStep(orderId) {//获得新的审核步骤
                const that = this;
                this.$axios.post("/admin/rfq/getStep", {orderId:orderId,
                    step:this.reviewForm.step,workflowId:this.reviewForm.workflowId})
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {
                            if( resp.data.review){
                                that.reviewForm.step = resp.data.step;
                                that.reviewForm.workflowId = resp.data.workflowId;
                                that.showBtn = true;

                            }else {
                                that.showBtn = false;
                            }


                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            },
            printOrder(){
                this.$bus.$emit('menuClose',true);
                html2canvas(this.$refs.p, {
                    width: this.$refs.p.clientWidth+20,
                    height: this.$refs.p.clientHeight,
                }).then((canvas) => {
                    const url = canvas.toDataURL();
                    printJS({
                        printable: url,
                        type: 'image',
                        documentTitle: '打印图片',
                        maxWidth: 9999,
                        style: `@media print { @page {size: auto; margin: 20px; } body{margin:0}}`
                    });
                });



            },

            hiddenHeaderRow({ rowIndex }) {
                if (rowIndex == 1) {
                    //隐藏第二行
                    return "hiddenClass";
                }
            },
            hiddenHeaderRow0({ rowIndex }) {
                if (rowIndex > 0) {
                    //隐藏第二行
                    return "hiddenClass";
                }
            },
            // 合并客户基本信息表格客户名称单元格
            arraySpanMethod1({ rowIndex, columnIndex }) {
                if (rowIndex == 0) {
                    if (columnIndex != 0) {
                        return [1, 2];
                    }
                }
            },
            tableHeaderColor ({ rowIndex, columnIndex }) {
                if (rowIndex === 0 && columnIndex === 0) {
                    return { background:'#dfdfdf',fontSize:'14px',color:'black'}
                } else if (rowIndex === 0 && columnIndex !== 0) {
                    return { background: '#dfdfdf', border: '1',color:'black'}
                } else {
                    return { background: '#dfdfdf'}
                }
            },
            //columnStyle( {row, column, rowIndex, columnIndex}) {
            columnStyle( { columnIndex}) {

                //第一三列
                if (columnIndex == 0 || columnIndex == 2) {
                    //字体颜色
                    return {background:'#dfdfdf',fontWeight:'bold',color:'black'};
                }
                return {fontSize:'14px',color:'black'};

            },
            columnStyleO() {
                return {fontSize:'14px',color:'black'};

            },
            orderIt(orderId,name,totalPrice) {//把订单状态从预下单改为下单

                //确定通过abc提交的总价￥123,456,78的订单吗?
                const that = this;
                this.$confirm('确定通过'  +'【' +name+'】提交的总价【￥'+totalPrice+'】的订单吗？', '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {

                    this.$axios.post("/admin/rfq/orderIt", orderId)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {

                                if (resp.data == true) {//
                                    that.$notify({
                                        title: '成功',
                                        message: '已下单',
                                        type: 'success'
                                    });
                                    that.showBtn = false;
                                    that.info();
                                } else {
                                    that.$notify({
                                        title: '提示',
                                        message: '下单失败',
                                        type: 'success'
                                    });

                                }

                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                });


            },

        },
        created() {
            let paramsStore;
            const params = sessionStorage.getItem("params");
            if(params) {
                paramsStore = JSON.parse(params);
            }
            const { name,totalPrice,orderId } = JSON.stringify(this.$route.params)== "{}"?paramsStore:this.$route.params;
            this.orderId =  orderId;
            this.reviewForm.orderId = orderId;
            this.reviewForm.name = name;
            this.reviewForm.totalPrice = totalPrice;
            //this.onSearch();
            this.info();

        },

    }
</script>
<style lang="scss" scoped>
    .hiddenClass {
        display: none !important;
    }
    /*.el-table-order{*/
    /*    max-width: 551px !important;*/
    /*    width: 551px !important;*/
    /*    margin-right: 10px;*/
    /*}*/
    /*::v-deep .tableBaseInfo {*/
    /*    .hiddenClass {*/
    /*        display: none !important;*/
    /*    }*/

    /*}*/

    /*::v-deep .el-table th {*/
    /*    border-color: black !important;*/

    /*}*/
    /*::v-deep .el-table td {*/
    /*    border-color: black !important;*/

    /*}*/
    /*::v-deep .el-table--group,*/
    /*::v-deep .el-table--border {*/
    /*    border: 0.5px solid black !important;*/
    /*}*/
    /*::v-deep .no-header-only.el-table--border {*/
    /*    border-top: 0.5px solid black !important;*/
    /*}*/
    /*::v-deep .no-header.el-table--border {*/
    /*    border-top: 0.5px solid black !important;*/
    /*}*/
    /*.el-table-o{*/

    /*    margin-right: 0px;*/
    /*}*/
    .quote {
        min-width: 1200px;
        margin: 0 auto;
        background-color: white;
    }
    .quote table {
        border-collapse: collapse;
    }
    .quote table td, .quote table th {
        border: 1px solid;
    }
    .quote .tr {
        table-layout:fixed;
        background-color: red;
    }
    .quote .thead .tr {

        background: white;
    }
    .quote .thead .th {
        height: 38px;
        line-height: 38px;
        text-align: center;
        font-weight: bold;
        color: #333;
        font-size: 16px;
        border-right: 1px solid #AED8FF  !important;
        display: inline-block;
    }
    .quote .tbody .tr {
        border-bottom: 2px solid red !important;
    }
    .quote .tbody .tr .td {
        font-size: 16px;
        font-weight: bold;
        height: 90px;
        display: inline-block;
        text-align: center;
    }
    .quote .tbody .tr .td img {
        width: 72px;
        height: 72px;
        margin-top: 9px;
    }
    .quote .tbody .tr .td .label {
        width: 182px;
        display: inline-block;
        height: 100%;
        margin-top: 5px;
    }
    .quote .quotePrice {
        display: inline-block;
    }
    .quote .quotePrice a {
        width: 22px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        border: 1px solid #cdcdcd  !important;
        background: #f2f2f2;
        float: left;
        color: #a6a6a6;
    }

    .quote .tbody .tr3 .td3 {
        font-weight: bold;
        font-size: 16px;
        height: 50px;
        line-height: 20px;
        display: inline-block;
        text-align: center;
        border-right: 1px solid #e4dada;
    }
    .quote .tbody .tr3{

        border-left: 1px solid #e4dada;
        border-bottom: 1px solid #e4dada;
    }

    .quote .tbody .tr1 .td1 {
        font-size: 16px;
        height: 38px;
        line-height: 38px;
        display: inline-block;
        text-align: center;
        border-right: 1px solid #e6e6e6;
    }
    .quote .tbody .tr1 {
        border-left: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
    }
    .quote .tbody .tr1 .td1 a {
        color: #000;
    }
    .quote .tbody .tr1 .td1 a:hover {
        color: #000;
    }
    .pt10{
        padding: 10px;
    }

</style>